<template>
    <header>
        <div class="box">
            <div class="burger" :class="{ open : open }" @click="open = !open">
                <span></span><span></span><span></span>
            </div>
            <div class="menu" :class="{ open : open }">
                <nav>
                    <router-link  v-if="can('news')" :to="{name : 'News'}" class="menu-link">News</router-link>
                    <router-link  v-if="can('events')" :to="{name : 'Events'}" class="menu-link">Events</router-link>
                    <router-link  v-if="can('press_release')" :to="{name : 'PressRelease'}" class="menu-link">Press <br />release</router-link>
                    <router-link  v-if="can('press_review')" :to="{name : 'PressReview'}" class="menu-link">Press <br />review</router-link>
                    <router-link  v-if="can('documents')" :to="{name : 'Documents'}" class="menu-link">Documentation</router-link>
                    <router-link  v-if="can('ifu')" :to="{name : 'IfuLots'}" class="menu-link">IFU <br />Lots</router-link>
                    <router-link  v-if="can('shareholders')" :to="{name : 'ShareholdersMeeting'}" class="menu-link">Shareholders <br />Meeting</router-link>
                    <router-link  v-if="can('career')" :to="{name : 'Career'}" class="menu-link">Career</router-link>
                    <router-link  v-if="can('calendar')" :to="{name : 'Calendar'}" class="menu-link">Calendar</router-link>
                    <router-link  v-if="can('users')" :to="{name : 'Users'}" class="menu-link" :class="{ 'router-link-active' : $route.name == 'Roles' }">Users <br />&amp; roles</router-link>
                </nav>
            </div>
            <div class="logout icon-otw_icon_logout" @click="logout()">
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name : "HeaderApp",
    data() {
        return {
            open : false
        }
    },
    watch : {
        // the menu closes when a page is opened
        '$route'() {
            this.open = false;
        }
    },
    methods : {
        can(permission) {
            return this.$store.getters.can(permission);
        },
        logout() {
            localStorage.removeItem("_safeToken");
            this.$store.commit("setUser", null);
            this.$router.push({name : "Home"});
        }
    }
}
</script>

<style lang="scss" scoped>
    header {
        width:100%;
        background:$mainColor;
        position:relative;
    }

    .burger {
        display:none;
        flex-direction: column;
        justify-content: space-between;
        width:30px;
        height:22px;
        cursor:pointer;
    }

    .burger span {
        display:block;
        height:3px;
        background:#fff;
        transition:0.3s;
    }

    .burger.open span:nth-child(1) {
        transform: translateY(9.5px) rotate(45deg);
    }

    .burger.open span:nth-child(2) {
        opacity:0;
    }

    .burger.open span:nth-child(3) {
        transform: translateY(-9.5px) rotate(-45deg);
    }
    .box {
        padding:20px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .logout {
        transition:0.5s;
        font-size:30px;
        cursor: pointer;
        color:#fff
    }

    .logout:hover {
        color:#000;
    }

    .menu-link {
        font-size:15px;
        font-weight: 400;
        color:#fff;
        cursor: pointer;
        text-transform: uppercase;
        margin:0 clamp(10px, 1.4vw, 30px);
        text-align: center;
    }

    .menu-link:hover, .router-link-exact-active {
        color:$black;
    }

    nav {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 10px;
    }

    /* menu in a drop-down on tablets and phones */
    @media (max-width: 1200px) {
        .box {
            padding:15px 0;
        }

        .burger {
            display:flex;
        }

        .menu {
            display:none;
            position:absolute;
            top:100%;
            left:0;
            right:0;
            background:$mainColor;
            z-index:50;
            box-shadow:0 10px 20px rgba(0,0,0,0.5);
        }

        .menu.open {
            display:block;
        }

        nav {
            flex-direction: column;
            align-items: stretch;
        }

        .menu-link {
            margin:0;
            padding:15px 6%;
            text-align:left;
            border-top:1px solid rgba(255,255,255,0.3);
        }

        .menu-link br {
            display:none;
        }
    }
</style>